import { NgModule } from '@angular/core';
import { SharedModule } from '../../../core/modules/shared.module';
import { SectionsRoutingModule } from './sections.routing.module';
import { CatalogComponent } from './catalog/catalog.component';
import { CommonModule } from '@angular/common';
import { NgxLoadingModule, ngxLoadingAnimationTypes  } from 'ngx-loading';
import { ModalModule } from 'ngx-bootstrap/modal';
import { ConsoleComponent } from './console/console.component';
import { ConsoleDetail } from './console/console-detail/console-detail';
import { ResizableModule } from 'angular-resizable-element';
import { EmployeesComponent } from './employees/employees.component';
import { EmployeesDetailComponent } from './employees/employees-detail/employees-detail.component';
import { RolesComponent } from './roles/roles.component';
import { RolesDetailsComponent } from './roles/roles-details/roles-details.component';
import { ActivitiesComponent } from './activities/activities.component';
import { ActiviyDetail } from './activities/activity-detail/activity-detail';
import { ActiviyAssignExam } from './activities/activity-assign-exam/activity-assign-exam';
import { ProjectsComponent } from './projects/projects.component';
import { ProjectDetail } from './projects/project-detail/project-detail';
import { ProjectAssignNDA } from './projects/project-assign-nda/project-assign-nda';
import { AreasComponent } from './areas/areas.component';
import { NdasmanagementComponent } from './ndasmanagement/ndasmanagement.component';
import { NdasmanagementDetailComponent } from './ndasmanagement/ndasmanagement-detail/ndasmanagement-detail.component';
import { EvidenceNDADetailComponent } from './ndasmanagement/ndasmanagement-detail/evidenceNDA-detail/evidenceNDA-detail.component';
import { IdentificationsTypes } from './identificationstypes/identificationstypes.component';
import { IdentificationsTypesDetailComponent } from './identificationstypes/identificationstypes-detail/identificationstypes-detail.component';
import { EquipmenttypesComponent } from './equipmenttypes/equipmenttypes.component';
import { EquipmentTypesDetailComponent } from './equipmenttypes/equipmenttypes-detail/equipmenttypes-detail.component';
import { CompanysuppliersComponent } from './companysuppliers/companysuppliers.component';
import { CompanysuppliersDetailComponent } from './companysuppliers/companysuppliers-detail/companysuppliers-detail.component';
import { AreaDetail } from './areas/area-detail/area-detail';
import { SitesComponent } from './sites/sites.component';
import { SiteDetailComponent } from './sites/site-detail/site-detail.component';
import { BuildingsComponent } from './buildings/buildings.component';
import { BuildingDetailComponent } from './buildings/building-detail/building-detail.component';
import { DocumentstypesComponent } from './documentstypes/documentstypes.component';
import { DocumenttypeDetailComponent } from './documentstypes/documenttype-detail/documenttype-detail.component';
import { DisableSiteComponent } from './sites/disable-site/disable-site.component';
import { EhsExamsComponent } from './ehs-exams/ehs-exams.component';
import { EHSExamsDetailComponent } from './ehs-exams/ehs-exams-detail/ehs-exams-detail.component';
import { EhsExamsResultsComponent } from './ehs-exams-results/ehs-exams-results.component';
import { SitesConfigurationsComponent } from './sites-configurations/sites-configurations.component';
import { SitesConfigurationsDetailsComponent } from './sites-configurations/sites-configurations-details/sites-configurations-details.component';
import { ExamsResultsDetailComponent } from './ehs-exams-results/exams-results-detail/exams-results-detail.component';
import { PrinterConfigurationsComponent } from './printer-configurations/printer-configurations.component';
import { PrinterConfigurationsDetailComponent } from './printer-configurations/printer-configurations-detail/printer-configurations-detail.component';
import { NewVisitComponent } from './my-requests/new-visit/new-visit.component';
import { DisableRoleComponent } from './roles/disable-role/disable-role.component';
import { ContactComponent } from './contact/contact.component';
import { LastReleaseComponent } from './last-release/last-release.component';
import { WithoutPermissionComponent } from './without-permission/without-permission.component';
import { TranslateModule } from '@ngx-translate/core';
import { MyRequestsComponent } from './my-requests/my-requests.component';
import { UploadImageComponent } from './my-requests/upload-image/upload-image.component';
import { JabilSearchEmployee } from './jabil-search-employee/jabil-search-employee.component';
import { UploadImagePhotoComponent } from './my-requests/upload-image-photo/upload-image-photo.component';
import { UploadDocumentComponent } from './my-requests/upload-document/upload-document.component';
import { MyApprovalsComponent } from './my-approvals/my-approvals.component';
import { MyApprovalsDetailsComponent } from './my-approvals/my-approvals-details/my-approvals-details.component';
import { HomeComponent } from './home/home.component';
import { ReportsComponent } from './reports/reports.component';
import { ApprovalHistoryComponent } from './my-requests/approval-history/approval-history.component';
import { RejectApprovalComponent } from './my-approvals/reject-approval/reject-approval.component';

@NgModule({
	entryComponents: [ConsoleDetail],
	imports: [
		SharedModule,
		SectionsRoutingModule,
    CommonModule,
    TranslateModule,
		ModalModule.forRoot(),
		NgxLoadingModule.forRoot({
			fullScreenBackdrop: true,
			backdropBackgroundColour: '3px',
		}),
		ResizableModule,
	],
	declarations: [
		CatalogComponent,
		ConsoleComponent,
		ConsoleDetail,
		EmployeesComponent,
		EmployeesDetailComponent,
		RolesComponent,
		RolesDetailsComponent,
		ConsoleDetail,
		ActivitiesComponent,
		ActiviyDetail,
		ActiviyAssignExam,
		ProjectsComponent,
		ProjectDetail,
		ProjectAssignNDA,
		AreasComponent,
		NdasmanagementComponent,
		NdasmanagementDetailComponent,
		EvidenceNDADetailComponent,
		ConsoleDetail,
		IdentificationsTypes,
		IdentificationsTypesDetailComponent,
		EquipmenttypesComponent,
		EquipmentTypesDetailComponent,
		CompanysuppliersComponent,
		CompanysuppliersDetailComponent,
		AreasComponent,
		AreaDetail,
		ConsoleDetail,
		SitesComponent,
		SiteDetailComponent,
		BuildingsComponent,
		BuildingDetailComponent,
		DocumentstypesComponent,
		DocumenttypeDetailComponent,
		DisableSiteComponent,
		EhsExamsComponent,
		EHSExamsDetailComponent,
		EhsExamsResultsComponent,
		SitesConfigurationsComponent,
		SitesConfigurationsDetailsComponent,
		ExamsResultsDetailComponent,
		PrinterConfigurationsComponent,
		PrinterConfigurationsDetailComponent,
		NewVisitComponent,
		DisableRoleComponent,
		ContactComponent,
		LastReleaseComponent,
		WithoutPermissionComponent,
    MyRequestsComponent,
    UploadImageComponent,
    JabilSearchEmployee,
    UploadImagePhotoComponent,
    UploadDocumentComponent,
    MyApprovalsComponent,
    MyApprovalsDetailsComponent,
    HomeComponent,
    ReportsComponent,
    ApprovalHistoryComponent,
    RejectApprovalComponent,
	],
})
export class SectionsModule {}
